import { render, staticRenderFns } from "./Fund-Dynamic.vue?vue&type=template&id=c18d2fd0&scoped=true&"
import script from "./Fund-Dynamic.vue?vue&type=script&lang=js&"
export * from "./Fund-Dynamic.vue?vue&type=script&lang=js&"
import style0 from "./Fund-Dynamic.vue?vue&type=style&index=0&id=c18d2fd0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18d2fd0",
  null
  
)

export default component.exports